// @ts-nocheck

import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import useMergeProps from '../../../../hooks/useMergeProps';
import BoomBetslipBand from '../common/BoomBetslipBand';

import makeBoomHistoryBetslipPropsSelector from './BoomHistoryBetslip.selector';

type BoomHistoryBetslipContainerProps = {
  className?: string;
  betslipId: number;
};

const BoomHistoryBetslipContainer = (props: BoomHistoryBetslipContainerProps) => {
  const { betslipId, ...ownProps } = props;
  const selector = useMemo(() => makeBoomHistoryBetslipPropsSelector(), []);
  const selectorProps = useMemo(() => ({ betslipId }), [betslipId]);
  const { isVisible, ...selectedProps } = useSelector((state) => selector(state, selectorProps));

  const enhancedProps = useMergeProps({ ownProps, selectedProps });

  return isVisible ? <BoomBetslipBand {...enhancedProps} isDark isCompact /> : null;
};

export default BoomHistoryBetslipContainer;
